import { Heading } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../translations';

export const ReceptionServiceListHeader = (): JSX.Element => {
   return (
      <Heading
         testId={'receptionServices'}
         type={'h3'}
         margin={'4px'}
         content={receptionServiceTranslationKeys.extensions.calendar.receptionServiceList.heading}
         bold
      />
   );
};
